var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ProgressBar',_vm._l((_vm.items),function(item,index){return _c('li',{key:index,class:{
        'is-complete': _vm.current > index + 1,
        'is-active': index + 1 === _vm.current,
        'is-hover': !!_vm.onCurrent,
      },on:{"click":() => _vm.onCurrent && _vm.onCurrent(index + 1)}},[_c('span',[_vm._v(_vm._s(item))])])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }